export enum PrioridadeEnum {
  BAIXA,
  MEDIA,
  ALTA,
  MUITO_ALTA
}

export const prioridadeEnum = {
  BAIXA: 'Baixa',
  MEDIA: 'Média',
  ALTA: 'Alta',
  MUITO_ALTA: 'Muito alta'
};
